<template>
    <div id="checkin">
        <div class="container">
            <form v-if="!isCheckIn" @submit.prevent="submitCheckin">
                <h3 class="swif-blue-color" style="word-wrap: break-word;">{{ branchname }}</h3>
                <br>
                <div class="form-group">
                    <input type="text" class="form-control" id="name" v-model="name" placeholder="Name">
                    <small id="error-name" class="form-text invalid-feedback"></small>
                </div>
                <div class="form-group">
                    <input type="number" class="form-control" id="phone" v-model="phone" placeholder="Contact No">
                    <small id="error-phone" class="form-text invalid-feedback"></small>
                </div>
                <div class="form-group">
                    <input type="number" class="form-control" id="temperature" step="0.01" min="20" max="45" v-model="temperature" placeholder="Body Temperature (Optional)">
                </div>
                <button type="submit" class="btn btn-swif-yellow">Submit</button>
            </form>
            <div v-if="isCheckIn">
                <br>
                <img class="center checkedimage" src="@/assets/images/success.gif">
                <div style="padding:10px;">
                    <h5 class="swif-blue-color" style="text-align:center;font-weight:800!important;">WELCOME TO</h5>
                </div>
                <div id="branchname" class="shadow-sm p-3">
                    <h6 class="swif-blue-color" style="text-align:center;text-transform: uppercase;word-wrap: break-word;"> {{ branchname }}</h6>
                </div>
                <div class="clearfix" style="padding:10px;">
                    <p class="swif-blue-color" style="float:left;">{{ date }}</p>
                    <p class="swif-blue-color" style="float:right;">{{ time }}</p>
                </div>
                <img style="width:100%;" src="@/assets/images/steps.png">
                <div class="clearfix" style="padding:10px;">
                    <img class="checkedimage" style="float:left;" src="@/assets/images/googleplay.png">
                    <img class="checkedimage" style="float:right;" src="@/assets/images/applestore.png">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.checkedimage{
    width: 50%;
}
#branchname{
    border-radius: 50px;
    background-color: #ffffff;
}
</style>
<script>
import $ from 'jquery'
import {firebaseApp,firebaseDefaultDateTime} from '../components/firebase/init'
const db = firebaseApp.firestore()   
export default{
    name: 'checkin',
    data(){
        return{
            name: "",
            phone: "",
            temperature: "",
            branchname: "",
            isCheckIn: false,
            date: "",
            time: ""
        }
    },
    beforeRouteEnter(to,from,next){
        const branch_id = to.params.branch_id;
        const str = to.params.branch_id.split("@");
        const merchant_id = str[0]+"@"+str[1];
        db.collection('merchant').doc(merchant_id)
        .collection('branch').doc(branch_id).get().then(doc=>{
            if(doc.exists){
                if(doc.data().status == "1"){
                    next(vm=>{
                        vm.branchname = doc.data().name
                    })
                }else{
                    next('/error404');
                }
            }else{
                next('/error404');
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
    },
    watch: {
        '$route':'getBranchName'
    },
    methods:{
        getBranchName(){
            const branch_id = this.$route.params.branch_id;
            const str = this.$route.params.branch_id.split("@");
            const merchant_id = str[0]+"@"+str[1];
            db.collection('merchant').doc(merchant_id)
            .collection('branch').doc(branch_id).get().then(doc=>{
                if(doc.exists){
                    if(doc.data().status == "1"){
                        this.branchname = doc.data().name;
                    }else{
                        this.$router.push('/error404')
                    }
                }else{
                   this.$router.push('/error404')
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
        },
        submitCheckin(){
            [].forEach.call(document.querySelectorAll('.is-invalid'), function (el) {
                el.classList.remove('is-invalid');
            });

            [].forEach.call(document.querySelectorAll('.invalid-feedback'), function (el) {
                el.innerHTML = "";
            });

            var valid = true;
            var name = this.name;
            var phone = this.phone;
            var temperature = this.temperature;
            var branchname = this.branchname;
            var today = new Date();
            var date = ("0" + today.getDate()).slice(-2)+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+today.getFullYear();
            var time = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2);
            const branch_id = this.$route.params.branch_id;
            const str = this.$route.params.branch_id.split("@");
            const merchant_id = str[0]+"@"+str[1];

            if(name.trim() == "" || name.length < 6){
                document.getElementById("name").classList.add("is-invalid");
                document.getElementById("error-name").innerHTML = "Name is invalid";
                valid = false;
            }

            if(phone.trim() == "" || (!(phone.length > 9 && phone.length < 12 ))){
                document.getElementById("phone").classList.add("is-invalid");
                document.getElementById("error-phone").innerHTML = "Contact No is invalid";
                valid = false;
            } 

            if(valid === true){
                $(".loader").show();
                db.collection('checkinlog').add({
                    datesort: firebaseDefaultDateTime.Timestamp.fromDate(new Date()),
                    date: date,
                    time: time,
                    name: name,
                    contactno: "+6"+phone,
                    temperature: temperature,
                    bid: branch_id,
                    mid: merchant_id,
                    uid: null,
                    branchname: branchname,
                    email: null,
                }).then(docRef =>
                    this.date = date, 
                    this.time = time,
                    this.isCheckIn = true, 
                    $(".loader").hide()
                ).catch(error => console.log(error))
            }
        }
    }
}
</script>